import { render } from "./IframePage.vue?vue&type=template&id=17772918"
import script from "./IframePage.vue?vue&type=script&lang=js"
export * from "./IframePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__